import actionCreator from "helpers/actionCreator"
import { call, put, select, takeEvery } from "redux-saga/effects"
import { del } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"
import { Creators as modelCreators } from "model/data"
import { getIntegrations } from "modules/platform/selectors/apps"
import { STATUSES } from "modules/platform/constants"
import { find } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/application/", {
  deactivateApplication: {
    props: ["account", "application"],
    track: true,
    trackType: "application-deactivation",
    trackPayload: ({ account, application }) => ({ account, application }),
  },
})

function* deactivateApplication({ account, application }) {
  try {
    yield call(del, `/api/${account}/deactivatePartner`, { partnerId: application.id })
    const { integrations } = yield select(state => ({
      integrations: getIntegrations(state),
    }))
    const updated = {
      ...find(integrations, integration => integration.id === application.id),
      status: STATUSES.NONE,
    }
    yield put(modelCreators.updateSuccess("integrations", null, null, updated, { updateCollection: `/api/${account}/accountPartners` }))
    yield put(modelCreators.resetCollections(["applicationPermissions", "accountApplications", "resourceApplications"]))
    yield put(notificationCreators.add("success", null, `${application.name} has been de-authorized.`))
  } catch {
    yield put(notificationCreators.add("error", null, "An unexpected error occured."))
  }
}

export function* saga() {
  yield takeEvery(Types.DEACTIVATE_APPLICATION, deactivateApplication)
}
